import React from 'react';
import { Box } from '@mui/material';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
}

export const EmptyState = ({ icon, title, description, action }: EmptyStateProps) => (
  <Box sx={{ py: 5, px: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 1 }}>
    {icon && (
      <Box sx={{ width: 44, height: 44, borderRadius: '12px', backgroundColor: 'var(--muted-bg)', color: 'var(--muted)', display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 0.5, '& svg': { fontSize: 22 } }}>
        {icon}
      </Box>
    )}
    <Box sx={{ fontSize: 15, fontWeight: 600 }}>{title}</Box>
    {description && <Box sx={{ fontSize: 13, color: 'var(--muted)', maxWidth: 360, lineHeight: 1.5 }}>{description}</Box>}
    {action && <Box sx={{ mt: 1 }}>{action}</Box>}
  </Box>
);
